import Blockly from "blockly";
import helpers from "blocks/helpers";

Blockly.Blocks.HoldPose = {
  message0: "hold pose for %1 beats",
  args0: [
    {
      type: "input_value",
      name: "duration",
      check: "Number",
    },
  ],
  previousStatement: "Statement",
  nextStatement: "Statement",
};

Blockly.Blocks.HoldPose.init = function () {
  this.jsonInit(Blockly.Blocks.HoldPose);
};

Blockly.JavaScript.HoldPose = function (block) {
  const duration = helpers.codeForArg("duration", block);

  if (typeof duration === "undefined") {
    return "";
  } else {
    return `visualisation.holdPose(${duration});`;
  }
};
